<template>
    <div class="theme2" v-if="currentProfile && currentProfile.deviceDetail">
        <!-- Use Theme 2 Header -->
        <KidHeaderTheme2 
            :profileId="currentProfile._id" 
            :serialNumber="currentProfile.deviceDetail.serialNumber"
            :profileList="profileList"
            :currentProfileIndex="profileList.findIndex(p => p._id === currentProfile._id)"
            @kid-selected="handleKidSelection"
            @tab-changed="handleTabChange"
        />

        <div class="theme2-container">
            <!-- Alerts -->
            <div v-if="currentProfile.deviceLimitReached" style="background: #fef3c7; border: 1px solid #fde68a; border-radius: 0.5rem; padding: 0.75rem; margin-bottom: 1rem;">
                <span style="color: #dc2626; font-weight: 700;">All applications have been disabled</span> because the device limit has been reached.
            </div>

            <!-- Profile Card - Option 1 Improved (Desktop + Mobile Optimized) -->
            <div class="theme2-profile-card">
                <!-- Header with Avatar and Name -->
                <div class="theme2-profile-header">
                    <div class="theme2-profile-info">
                        <div :class="['theme2-profile-avatar', getAvatarBgClass(currentProfile)]">
                            {{ getAvatarEmoji(currentProfile) }}
                            <div class="theme2-online-indicator" :style="{ background: currentProfile.deviceDetail.wifiConnected ? '#10b981' : '#9ca3af' }"></div>
                        </div>
                        <div style="flex: 1; min-width: 0;">
                            <h2 class="theme2-profile-name">{{ currentProfile.profile_name }}</h2>
                            <p class="theme2-profile-rules">
                                Version: {{ currentProfile?.deviceDetail?.appVersion }}
                            </p>
                        </div>
                    </div>
                </div>
                <!-- Wrap status row and actions in container (DESKTOP ONLY via CSS) -->
<div class="theme2-status-actions-wrapper">
    <!-- Status Row - Battery, Internet, Last Update -->
    <div class="theme2-status-row">
        <div class="theme2-status-badge">
            <span :style="{ color: getBatteryColor(currentProfile.deviceDetail.batteryPercentage) }">
                {{ getBatteryIcon(currentProfile.deviceDetail.batteryPercentage) }}
            </span>
            <span>{{ currentProfile.deviceDetail.batteryPercentage }}%</span>
        </div>
        
        <div class="theme2-status-badge">
            <span>{{ currentProfile.deviceDetail.wifiConnected ? '🌐' : '📵' }}</span>
            <span>{{ currentProfile.deviceDetail.wifiConnected ? 'Online' : 'Offline' }}</span>
        </div>
        
        <div class="theme2-status-badge theme2-last-update-badge">
            <span>🕐</span>
            <span>{{ lastUpdated }}</span>
        </div>
    </div>

    <!-- Action Buttons Row -->
    <div class="theme2-actions-row">
        <button @click="toggleSleepMode" class="theme2-action-btn" :class="{ 'active': sleepMode }">
            <span>🌙</span>
            <span>{{ sleepMode ? 'Sleep On' : 'Sleep Mode' }}</span>
        </button>
        
        <button @click="openEditKidModal" class="theme2-action-btn">
            <span>✏️</span>
            <span>Edit</span>
        </button>
    </div>
</div>
            </div>
            <!-- Kid Profile Card -->
            <!--<div class="theme2-profile-card">
                <div class="theme2-profile-header">
                    <div class="theme2-profile-info">
                        <div :class="['theme2-profile-avatar', getAvatarBgClass(currentProfile)]">
                            {{ getAvatarEmoji(currentProfile) }}
                            <div class="theme2-online-indicator" :style="{ background: currentProfile.deviceDetail.wifiConnected ? '#10b981' : '#9ca3af' }"></div>
                        </div>
                        <div>
                            <h2 class="theme2-profile-name">{{ currentProfile.profile_name }}</h2>
                            <p class="theme2-profile-rules">
                                Version: {{ currentProfile?.deviceDetail?.appVersion }}
                            </p>
                        </div>
                    </div>
                    <div style="text-align: right; flex-shrink: 0;">
                        <div class="theme2-last-update">
                            <p class="theme2-last-update-label">Last Update</p>
                            <p class="theme2-last-update-time">{{ lastUpdated }}</p>
                        </div>
                    </div>
                </div>

                <div style="display: flex; flex-wrap: wrap; gap: 0.5rem; margin-bottom: 0.75rem;">
                    <div style="display: flex; align-items: center; gap: 0.375rem; background: rgba(255, 255, 255, 0.2); backdrop-filter: blur(10px); border-radius: 0.5rem; padding: 0.25rem 0.75rem;">
                        <span
                            style="font-size: 1.125rem;"
                            :style="{ color: getBatteryColor(currentProfile.deviceDetail.batteryPercentage) }"
                        >
                            {{ getBatteryIcon(currentProfile.deviceDetail.batteryPercentage) }}
                        </span>

                        <span style="font-size: 0.875rem; color: white; font-weight: 700;">
                            {{ currentProfile.deviceDetail.batteryPercentage }}%
                        </span>
                    </div>

                    <div style="display: flex; align-items: center; gap: 0.375rem; background: rgba(255, 255, 255, 0.2); backdrop-filter: blur(10px); border-radius: 0.5rem; padding: 0.25rem 0.75rem;">
                        <span style="font-size: 1.125rem;">{{ currentProfile.deviceDetail.wifiConnected ? '🌐' : '📵' }}</span>
                        <span style="font-size: 0.875rem; color: white; font-weight: 700;">{{ currentProfile.deviceDetail.wifiConnected ? 'Connected' : 'Offline' }}</span>
                    </div>
                </div>

                <div style="display: flex; gap: 0.5rem;">
                    <button 
                        @click="toggleSleepMode" 
                        :style="{ 
                            flex: 1, 
                            background: sleepMode ? '#a855f7' : 'rgba(255, 255, 255, 0.2)', 
                            backdropFilter: 'blur(10px)', 
                            borderRadius: '0.5rem', 
                            padding: '0.5rem 0.75rem', 
                            fontWeight: 600, 
                            fontSize: '0.875rem', 
                            color: 'white',
                            border: 'none',
                            cursor: 'pointer'
                        }"
                    >
                        {{ sleepMode ? '🌙 Sleep Mode On' : '🌙 Sleep Mode Off' }}
                    </button>
                    <button 
                        @click="openEditKidModal"
                        style="
                            flex: 1; 
                            background: rgba(255, 255, 255, 0.2); 
                            backdrop-filter: blur(10px); 
                            border-radius: 0.5rem; 
                            padding: 0.5rem 0.75rem; 
                            font-weight: 600; 
                            font-size: 0.875rem; 
                            color: white;
                            border: none;
                            cursor: pointer;
                        "
                    >
                        ✏️ Edit Kid
                    </button>
                </div>
            </div>-->

            <!-- Sleep Mode Banner -->
            <div v-if="sleepMode" style="background: #faf5ff; border: 1px solid #e9d5ff; border-radius: 0.5rem; padding: 1rem; margin-bottom: 1rem; display: flex; align-items: center; gap: 0.75rem;">
                <div style="font-size: 1.875rem;">🌙</div>
                <div style="flex: 1;text-align:left">
                    <p style="font-weight: 700; color: #7c3aed;">Sleep Mode Active</p>
                    <p style="font-size: 0.875rem; color: #6b21a8;">Device is in sleep mode. All apps are blocked except emergency calls.</p>
                </div>
                <button @click="toggleSleepMode" style="padding: 0.5rem 1rem; background: #7c3aed; color: white; border-radius: 0.5rem; font-weight: 500; font-size: 0.875rem; border: none; cursor: pointer;">
                    Turn Off
                </button>
            </div>
            
            <!-- Stats Grid -->
            <div class="theme2-stats-grid">
                <div class="theme2-stat-card" style="border-color: #bfdbfe; background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 50%, white 100%);">
                    <div class="theme2-stat-icon">⏱️</div>
                    <h4 class="theme2-stat-title">Screen Time</h4>
                    <p class="theme2-stat-value" style="color: #0ea5e9;">{{ totalUsedTime || '0m' }}</p>
                </div>
                <div class="theme2-stat-card" style="border-color: #bbf7d0; background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 50%, white 100%);">
                    <div class="theme2-stat-icon">📱</div>
                    <h4 class="theme2-stat-title">Apps Used</h4>
                    <p class="theme2-stat-value" style="color: #10b981;">{{ totalMostUsedApps || 0 }}</p>
                </div>
                <div class="theme2-stat-card" style="border-color: #bfdbfe; background: linear-gradient(135deg, #fef2f2 0%, #fee2e2 50%, white 100%); cursor: pointer;" @click="openProtectionModal"> <!-- :class="{ 'theme2-stat-card-error': currentProfile?.deviceDetail?.kidsApplicationStatus !== 'Healthy' }" -->
                    <div class="theme2-stat-icon">🛡️</div>
                    <h4 class="theme2-stat-title">Protection</h4>
                    <p class="theme2-stat-value" :style="{ color: currentProfile?.deviceDetail?.kidsApplicationStatus === 'Healthy' ? '#3b82f6' : '#ef4444' }">
                        {{ currentProfile?.deviceDetail?.kidsApplicationStatus === 'Healthy' ? 'Active' : 'Error' }}
                    </p>
                    <span v-if="currentProfile?.deviceDetail?.kidsApplicationStatus !== 'Healthy'" style="font-size: 0.65rem; color: #dc2626; font-weight: 600;">⚠️ Click to view</span>
                    <span v-else style="font-size: 0.65rem; color: #10b981; font-weight: 600;">All permissions granted</span>
                </div>
                <div class="theme2-stat-card" style="border-color: #fecaca; background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 50%, white 100%); cursor: pointer;" @click="openAlertsModal">
                    <div class="theme2-stat-icon">⚠️</div>
                    <h4 class="theme2-stat-title">Alerts</h4>
                    <p class="theme2-stat-value" style="color: #ef4444;">{{ alertsCount }}</p>
                    <span v-if="alertsCount > 0" style="font-size: 0.65rem; color: #dc2626; font-weight: 600;">Click to view</span>
                    <span v-else style="font-size: 0.65rem; color: #10b981; font-weight: 600;">All clear!</span>
                </div>
            </div>

            <!-- Location & Activity Chart -->
            <div class="theme2-location-chart-grid">
                <!-- Location -->
                <div class="theme2-card">
                    <div class="theme2-card-header">
                        <h5 class="theme2-card-title text-left">Last Location</h5>
                        <div style="display: flex; gap: 0.5rem; font-size: 0.75rem;">
                            <span>📍</span>
                            <div>
                                <p style="color: #6b7280;">Updated {{ formatDateTime(currentProfile?.deviceDetail?.lastDeviceLocation?.deviceDateTime) }}</p>
                            </div>
                        </div>
                    </div>
                    <div style="position: relative; height: 100%; background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%); display: flex; align-items: center; justify-content: center;">
                        <iframe
                            v-if="iframeMapUrl && showMap"
                            :src="iframeMapUrl"
                            width="100%"
                            height="100%"
                            style="border: 0;"
                            allowfullscreen=""
                            loading="lazy"
                        ></iframe>
                        <div v-else :class="['theme2-profile-avatar', getAvatarBgClass(currentProfile)]" style="width: 2.5rem; height: 2.5rem; border: 4px solid white; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); font-size: 1.125rem;">
                            {{ getAvatarEmoji(currentProfile) }}
                        </div>
                    </div>
                </div>

                <!-- Activity Chart -->
                <div class="theme2-card">
                    <div class="theme2-card-body">
                        <h5 class="theme2-card-title text-left" style="margin-bottom: 0.75rem;padding:1rem;">Activity</h5>
                        
                        <!-- Day/Week Toggle -->
                        <div class="theme2-filter-toggle" style="margin-bottom: 0.75rem;">
                            <button 
                                @click="changeFilterType('Day')"
                                :class="['theme2-filter-btn', { 'active': filterType === 'day' }]"
                            >
                                Day
                            </button>
                            <button 
                                @click="changeFilterType('Week')"
                                :class="['theme2-filter-btn', { 'active': filterType === 'week' }]"
                            >
                                Week
                            </button>
                        </div>

                        <!-- Date Navigation -->
                        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 0.75rem; background: #f9fafb; border-radius: 0.5rem; padding: 0.5rem;">
                            <button @click="previousDate" style="padding: 0.375rem; background: none; border: none; cursor: pointer; border-radius: 0.5rem; transition: background 0.2s;" @mouseover="$event.currentTarget.style.background = '#e5e7eb'" @mouseleave="$event.currentTarget.style.background = 'transparent'">
                                <svg style="width: 1rem; height: 1rem; color: #6b7280;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"></path>
                                </svg>
                            </button>
                            <span style="font-weight: 600; font-size: 0.875rem; color: #111827;">{{ formattedDate }}</span>
                            <button @click="nextDate" style="padding: 0.375rem; background: none; border: none; cursor: pointer; border-radius: 0.5rem; transition: background 0.2s;" @mouseover="$event.currentTarget.style.background = '#e5e7eb'" @mouseleave="$event.currentTarget.style.background = 'transparent'">
                                <svg style="width: 1rem; height: 1rem; color: #6b7280;" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                                </svg>
                            </button>
                        </div>

                        <!-- Screen Time Display -->
                        <div style="margin-bottom: 0.75rem;">
                            <p style="font-size: 0.75rem; color: #6b7280; margin-bottom: 0.125rem;">Screen Time: <span style="font-weight: 700; color: #06b6d4; font-size: 1rem;">{{ totalUsedTime || '0m' }}</span></p>
                            <div style="display: flex; align-items: center; gap: 0.375rem;justify-content:center;">
                                <p style="font-size: 0.75rem; color: #6b7280;">Daily Recommendation</p>
                                <button 
                                    @click="openScreenTimeRecommendation" 
                                    style="width: 0.875rem; height: 0.875rem; background: #111827; color: white; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 0.75rem; border: none; cursor: pointer; outline: none;"
                                >
                                    i
                                </button>
                            </div>
                        </div>

                        <!-- Chart Placeholder -->
                        <CanvasJSChart v-if="mostUsedApplicationList.length > 0" :options="options" :styles="styleOptions"/>
                        <div v-else>
                            <img v-if="filterType == 'Day'" :src="dayNoDataGraph" class="img-fluid" />
                            <img v-else :src="weekNoDataGraph" class="img-fluid" />
                        </div>

                    </div>
                </div>
            </div>

            <!-- App Usage & Category Usage -->
            <div class="theme2-usage-grid">
                <!-- App Usage -->
                <div class="theme2-card">
                    <div class="theme2-card-body">
                        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 1rem;">
                            <h5 class="theme2-card-title" :style="{'padding': '1rem'}">App Usage</h5>
                            <div class="theme2-filter-toggle">
                                <button 
                                    @click="changeFilterType('Day')"
                                    :class="['theme2-filter-btn', { 'active': usageFilter === 'daily' }]"
                                >
                                    Daily
                                </button>
                                <button 
                                    @click="changeFilterType('Week')"
                                    :class="['theme2-filter-btn', { 'active': usageFilter === 'weekly' }]"
                                >
                                    Weekly
                                </button>
                            </div>
                        </div>
                        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
                            <div v-for="(app, index) in displayedMostUsedApps" :key="index" class="theme2-usage-item">
                                <div class="theme2-usage-info">
                                    <div class="theme2-usage-icon-wrapper">
                                        <div class="theme2-usage-icon" :style="{ background: getAppIconBg(index) }">
                                            <img v-if="app?.playStoreDetail?.icon" :src="app.playStoreDetail.icon" style="width: 1.5rem; height: 1.5rem; border-radius: 0.25rem;" />
                                            <span v-else>📱</span>
                                        </div>
                                        <div>
                                            <p class="theme2-usage-name">{{ app?.playStoreDetail?.title || app?.packageName }}</p>
                                            <p class="theme2-usage-time">{{ (app.timeInMinuteFormatted) }}</p>
                                        </div>
                                    </div>
                                    <span v-if="app.dailyLimit" class="theme2-usage-percentage">{{ (Math.ceil(app.progressBarPercentage * 100) / 100).toFixed(2) }}%</span>
                                </div>
                                <div class="theme2-progress-bar" v-if="app.dailyLimit">
                                    <div class="theme2-progress-fill" :style="{ width: (Math.ceil(app.progressBarPercentage * 100) / 100).toFixed(2) + '%', background: getAppBarColor(index) }"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Category Usage -->
                <div class="theme2-card">
                    <div class="theme2-card-body">
                        <h5 class="theme2-card-title" style="margin-bottom: 1rem;">Category Usage</h5>
                        <div style="display: flex; flex-direction: column; gap: 0.75rem;">
                            <div v-for="(category, index) in displayedMostUsedCategory" :key="index" class="theme2-usage-item">
                                <div class="theme2-usage-info">
                                    <div class="theme2-usage-icon-wrapper">
                                        <div class="theme2-usage-icon" :style="{ background: getCategoryIconBg(category.category), opacity: 0.2 }">
                                            {{ getCategoryIcon(category.category) }}
                                        </div>
                                        <div>
                                            <a class="theme2-usage-name" @click="$router.push({ path: '/category', query: { id: category._id, profileId: this.currentProfile._id, serialNumber: this.currentProfile.deviceDetail.serialNumber }})" href="javascript:void(0)">{{ category.category }}</a>
                                            <p class="theme2-usage-time">{{ (category.usedTimeFormat) }} </p>
                                        </div>
                                    </div>
                                    <span class="theme2-usage-percentage" v-if="category.enableDailyLimit">{{ (Math.ceil(category.progressBarPercentage * 100) / 100).toFixed(2) }}%</span>
                                </div>
                                <div class="theme2-progress-bar" v-if="category.enableDailyLimit">
                                    <div class="theme2-progress-fill" :style="{ width: (Math.ceil(category.progressBarPercentage * 100) / 100).toFixed(2) + '%', background: getCategoryIconBg(category.category) }"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Alerts Modal -->
        <div v-if="showAlertsModal" class="theme2-modal-overlay show" @click="closeAlertsModal">
            <div 
                class="theme2-modal-panel show theme2-alerts-modal" 
                @click.stop
            >
                <div class="theme2-modal-header">
                    <h3 class="theme2-modal-title">⚠️ System Alerts</h3>
                    <button class="theme2-modal-close" @click="closeAlertsModal">✕</button>
                </div>
                <div class="theme2-modal-content" style="max-height: calc(80vh - 4rem); overflow-y: auto; padding: 0;">
                    <div v-if="alerts.length === 0" style="padding: 3rem; text-align: center; color: #6b7280;">
                        <div style="font-size: 3rem; margin-bottom: 1rem;">✅</div>
                        <p style="font-size: 1.125rem; font-weight: 600; color: #10b981;">All Clear!</p>
                        <p style="font-size: 0.875rem; margin-top: 0.5rem;">No alerts at this time</p>
                    </div>
                    
                    <!-- Alert Items -->
                    <div v-for="(alert, index) in alerts" :key="index" class="alert-item" :class="'alert-' + alert.type">
                        <div class="alert-icon">
                            {{ alert.icon }}
                        </div>
                        <div class="alert-content">
                            <div class="alert-title">{{ alert?.title }}</div>
                            <div class="alert-message" v-html="alert.message"></div>
                            <button 
                                v-if="alert.action" 
                                @click="handleAlertAction(alert.action)"
                                class="alert-action-btn"
                            >
                                {{ alert.actionLabel }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Edit Kid Profile Modal -->
        <div v-if="showEditKidModal" class="theme2-modal-overlay show" @click="closeEditKidModal">
            <div 
                class="theme2-modal-panel show theme2-alerts-modal" 
                @click.stop
            >
                <div class="theme2-modal-header">
                    <h3 class="theme2-modal-title">✏️ Update Kid's Profile</h3>
                    <button class="theme2-modal-close" @click="closeEditKidModal">✕</button>
                </div>
                <div class="theme2-modal-content" style="max-height: calc(80vh - 4rem); overflow-y: auto; padding: 1.5rem;">
                    <form @submit.prevent="updateKidProfileDetail">
                        <!-- Kid's Name -->
                        <div style="margin-bottom: 1rem;">
                            <label style="display: block; font-weight: 600; color: #374151; margin-bottom: 0.5rem; font-size: 0.875rem;">Kid's Name</label>
                            <input 
                                type="text" 
                                v-model="kidName" 
                                required
                                style="width: 100%; padding: 0.5rem 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem;"
                                placeholder="Enter kid's name"
                            >
                        </div>

                        <!-- Birth Month -->
                        <div style="margin-bottom: 1rem;">
                            <label style="display: block; font-weight: 600; color: #374151; margin-bottom: 0.5rem; font-size: 0.875rem;">Birth Month</label>
                            <select 
                                v-model.number="birthMonth" 
                                required
                                style="width: 100%; padding: 0.5rem 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem;"
                            >
                                <option disabled value="">Select month</option>
                                <option v-for="month in months" :key="month.value" :value="month.value">
                                    {{ month.name }}
                                </option>
                            </select>
                        </div>

                        <!-- Birth Year -->
                        <div style="margin-bottom: 1rem;">
                            <label style="display: block; font-weight: 600; color: #374151; margin-bottom: 0.5rem; font-size: 0.875rem;">Birth Year</label>
                            <input 
                                type="number" 
                                v-model="birthYear" 
                                :min="2000" 
                                :max="new Date().getFullYear()" 
                                required
                                style="width: 100%; padding: 0.5rem 0.75rem; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem;"
                                placeholder="Enter birth year"
                            >
                        </div>

                        <!-- Profile Picture -->
                        <div style="margin-bottom: 1.5rem;">
                            <label style="display: block; font-weight: 600; color: #374151; margin-bottom: 0.5rem; font-size: 0.875rem;">Profile Picture</label>
                            <div style="display: flex; gap: 1rem; margin-bottom: 1rem;">
                                <!-- Existing Image -->
                                <div v-if="existingProfilePic" style="text-align: center;">
                                    <small style="display: block; color: #6b7280; margin-bottom: 0.25rem;">Current</small>
                                    <img :src="existingProfilePic" alt="Current Profile" style="width: 100px; height: 100px; object-fit: cover; border-radius: 0.5rem; border: 2px solid #e5e7eb;">
                                </div>

                                <!-- New Image Preview -->
                                <div v-if="newProfilePic" style="text-align: center;">
                                    <small style="display: block; color: #6b7280; margin-bottom: 0.25rem;">New</small>
                                    <img :src="newProfilePic" alt="New Preview" style="width: 100px; height: 100px; object-fit: cover; border-radius: 0.5rem; border: 2px solid #06b6d4;">
                                </div>
                            </div>

                            <!-- File Input -->
                            <input 
                                type="file" 
                                @change="handleFileUpload" 
                                accept="image/*"
                                style="width: 100%; padding: 0.5rem; border: 1px solid #d1d5db; border-radius: 0.5rem; font-size: 0.875rem;"
                            >
                        </div>

                        <!-- Submit Button -->
                        <div style="display: flex; gap: 0.75rem;">
                            <button 
                                type="button"
                                @click="closeEditKidModal"
                                style="flex: 1; padding: 0.75rem; background: #f3f4f6; color: #374151; border: none; border-radius: 0.5rem; font-weight: 600; cursor: pointer;"
                            >
                                Cancel
                            </button>
                            <button 
                                type="submit"
                                :disabled="isDisabled"
                                style="flex: 1; padding: 0.75rem; background: linear-gradient(135deg, #06b6d4 0%, #0891b2 100%); color: white; border: none; border-radius: 0.5rem; font-weight: 600; cursor: pointer;"
                            >
                                <span v-if="!isDisabled">Save Changes</span>
                                <span v-else>Saving... <i class="fa fa-spinner fa-spin"></i></span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        
        <!-- Protection Error Modal -->
        <div v-if="showProtectionModal && currentProfile?.deviceDetail?.kidsApplicationStatus !== 'Healthy'" class="theme2-modal-overlay show" @click="closeProtectionModal" style="z-index: 1999;">
            <div 
                class="theme2-modal-panel show theme2-alerts-modal" 
                @click.stop
                style="z-index: 2000;"
            >
                <div class="theme2-modal-header">
                    <h3 class="theme2-modal-title">⚠️ Protection Error</h3>
                    <button class="theme2-modal-close" @click="closeProtectionModal">✕</button>
                </div>
                <div class="theme2-modal-content" style="padding: 1.5rem;">
                    <div class="alert-item alert-danger">
                        <div class="alert-icon">⚠️</div>
                        <div class="alert-content">
                            <div class="alert-title">Missing Permissions</div>
                            <div class="alert-message">
                                <p style="margin-bottom: 1rem;"><strong>Following permissions are missing:</strong></p>
                                <p style="background: #fef2f2; padding: 0.75rem; border-radius: 0.5rem; border-left: 3px solid #dc2626; margin-bottom: 1rem;">
                                    {{ currentProfile.deviceDetail.additionalData }}
                                </p>
                                <p>Please launch Padlock app on kid's device and grant the requested permissions.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Screen Time Recommendation Modal -->
        <div v-if="showScreenTimeModal" class="theme2-modal-overlay show" @click="closeScreenTimeRecommendation" style="z-index: 1999;">
            <div 
                class="theme2-modal-panel show theme2-alerts-modal" 
                @click.stop
                style="z-index: 2000; max-height: 90vh;"
            >
                <div class="theme2-modal-header">
                    <h3 class="theme2-modal-title">📊 Screen Time Recommendation</h3>
                    <button class="theme2-modal-close" @click="closeScreenTimeRecommendation">✕</button>
                </div>
                <div class="theme2-modal-content" style="padding: 1.5rem; max-height: calc(90vh - 5rem); overflow-y: auto;">
                    <div style="background: #eff6ff; border-left: 4px solid #3b82f6; padding: 1rem; border-radius: 0.5rem; margin-bottom: 1rem;">
                        <div v-html="kidScreenTimeRecommendation" style="color: #1e40af; line-height: 1.6; margin-bottom: 1rem;"></div>
                    </div>
                    
                    <div style="background: #f0fdf4; border-left: 4px solid #10b981; padding: 1rem; border-radius: 0.5rem; margin-bottom: 1rem;">
                        <p style="color: #166534; line-height: 1.6; margin: 0;">
                            <strong>Exception:</strong> Screen time monitoring excludes background audio usage. Music and audiobooks playing in the background are not tracked and don't count toward daily limits.
                        </p>
                    </div>
                    
                    <div style="text-align: center; padding: 1rem; background: #fafafa; border-radius: 0.5rem;">
                        <p style="color: #6b7280; margin-bottom: 0.75rem; font-size: 0.875rem;">For more information:</p>
                        <a 
                            href="https://www.projuventute.ch/de/eltern/medien-internet/bildschirmzeit" 
                            target="_blank"
                            style="display: inline-flex; align-items: center; gap: 0.5rem; padding: 0.75rem 1.5rem; background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); color: white; text-decoration: none; border-radius: 0.5rem; font-weight: 600; font-size: 0.875rem;"
                        >
                            Learn More
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                                <polyline points="15 3 21 3 21 9"></polyline>
                                <line x1="10" y1="14" x2="21" y2="3"></line>
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Use Theme 2 Footer -->
        <KidFooterTheme2 
            :profileId="currentProfile._id" 
            :serialNumber="currentProfile.deviceDetail.serialNumber"
            :enableSchedule="enableSchedule"
        />
    </div>
</template>

<script>
import KidHeaderTheme2 from '../../components/theme2/KidHeader2.vue';
import KidFooterTheme2 from '../../components/theme2/KidFooter2.vue';
import KidsService from '@/services/KidsService.js';
import ProfileService from "../../services/ProfileService";
import UserService from "../../services/UserService";

export default {
  name: 'DeviceDetailTheme2',
  components: {
    KidHeaderTheme2,
    KidFooterTheme2
  },
  data() {
    return {
      currentProfile: null,
      profileList: [],
      profileId: this.$route.query.profileId,
      serialNumber: this.$route.query.serialNumber,
      profileName: '',
      showNoDeviceSection: false,
      sleepMode: false,
      lastUpdated: 'Loading...',
      filterType: 'day',
      usageFilter: 'daily',
      currentDate: new Date(),
      weekType: 'week',
      iframeMapUrl: '',
      fullMapRedirectUrl: '',
      showMap: true,
      requestCount: 0,
      enableSchedule: false,
      totalUsedTime: '0m',
      totalMostUsedApps: 0,
      totalMostUsedCategory: 0,
      mostUsedApplicationList: [],
      allMostUsedApplicationList: [],
      mostUsedCategoryList: [],
      allMostUsedCategory: [],
      kidName: '',
      kidAge: 0,
      birthMonth: '',
      birthYear: '',
      existingProfilePic: null,
      kidsAppProtectionStatus: false,
      kidScreenTimeRecommendation: '',
      
      mediaVouchers: 'https://www.klicksafe.de/fileadmin/cms/download/Material/Div._Printmedium/Mediengutscheine_klicksafe_Deutsch_2021.pdf',
      chartCategories: [
        { name: 'Communication', color: '#3B82F6' },
        { name: 'Social', color: '#10B981' },
        { name: 'Music & Audio', color: '#8B5CF6' },
        { name: 'Tools', color: '#06B6D4' },
        { name: 'Others', color: '#84CC16' }
      ],
      options: null,
      styleOptions: {
          width: "100%",
          height: "250px"
      },
      pageSize: 6,
      currentMostUsedAppsPage: 1,
      formattedDate: new Date().toLocaleDateString("en-US", this.$dateOptions),

      showAlertsModal: false,
      useDefaultPassword: this.$route.query.useDefaultPassword || 'false',
    showScreenTimeModal: false,
      showProtectionModal: false,
      showEditKidModal: false,
        newProfilePic: null,
        kidProfileImagePayload: null,
        months: [
            { name: 'January', value: 1 },
            { name: 'February', value: 2 },
            { name: 'March', value: 3 },
            { name: 'April', value: 4 },
            { name: 'May', value: 5 },
            { name: 'June', value: 6 },
            { name: 'July', value: 7 },
            { name: 'August', value: 8 },
            { name: 'September', value: 9 },
            { name: 'October', value: 10 },
            { name: 'November', value: 11 },
            { name: 'December', value: 12 }
        ],
    }
  },
  props: {
    topLeftImage: {
        type: String,
        default: "./images/home-top-left.png",
    },
    appListIcon: {
        type: String,
        default: "./images/app-list-icon.png",
    },
    dayNoDataGraph: {
        type: String,
        default: "./images/day-nodata-graph.png",
    },
    weekNoDataGraph: {
        type: String,
        default: "./images/week-nodata-graph.png",
    },
    enrollmentQrCode: {
        type: String,
        default: "./images/kids-default-enrollment-qr-code.png",
    },
    logo: {
        type: String,
        default: "./images/lya-logo.png",
    },
    mediaVouchers: {
        type: String,
        default: "./images/mediengutscheine_diverses-printmedium_klicksafe.pdf",
    },
  },
  computed: {
    formatCurrentDate() {
      const options = { weekday: 'short', month: 'long', day: 'numeric' };
      return this.currentDate.toLocaleDateString('en-US', options);
    },
    displayedMostUsedApps() {
      return this.mostUsedApplicationList.slice(0, 6);
    },
    displayedMostUsedCategory() {
      return this.mostUsedCategoryList.slice(0, 5);
    },
    $dateOptions() {
      return { year: 'numeric', month: 'short', day: 'numeric' };
    },
    alerts() {
        const alertsList = [];
        
        // Device Limit Reached Alert
        if (this.currentProfile?.deviceLimitReached) {
            alertsList.push({
                type: 'danger',
                icon: '🚫',
                title: 'All Applications Disabled',
                message: '<strong>All applications have been disabled</strong> because the device limit has been reached. Please increase the device limit to re-enable them now; otherwise, all applications will be automatically re-enabled when the day changes.',
                action: null,
                actionLabel: null
            });
        }
        
        // Default Password Alert
        if (this.useDefaultPassword === 'true') {
            alertsList.push({
                type: 'warning',
                icon: '🔐',
                title: 'Default Password in Use',
                message: 'You are currently using the default password. Update your password for enhanced security.',
                action: 'change-password',
                actionLabel: 'Change Password'
            });
        }
        
        // Full Device Access Alert
        if (this.currentProfile?.deviceDetail?.protectionEnabled == "2") {
            alertsList.push({
                type: 'warning',
                icon: '⚡',
                title: 'Full Access Enabled',
                message: 'Allow Full Access has been enabled. The device may be able to bypass security restrictions, potentially exposing the system to unauthorized actions or data access.',
                action: 'global-settings',
                actionLabel: 'Change Settings'
            });
        }
        
        return alertsList;
    },
    
    alertsCount() {
        return this.alerts.length;
    }
  },
  methods: {
    openAlertsModal() {
        this.showAlertsModal = true;
    },
    
    closeAlertsModal() {
        this.showAlertsModal = false;
    },
    
    handleAlertAction(action) {
        this.closeAlertsModal();
        
        if (action === 'change-password') {
        this.$router.push({ path: '/change-password' });
        } else if (action === 'global-settings') {
        this.$router.push({ 
            path: '/global-settings', 
            query: { 
            profileId: this.currentProfile?._id, 
            serialNumber: this.currentProfile?.deviceDetail?.serialNumber 
            } 
        });
        }
    },
    changeFilterType(type) {
        this.filterType = type;
        if (this.filterType == "Day") {
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
        } else {
            this.formattedDate = "This Week";
            this.weekType = "Current";
        }
    },
    formatDateTime(datetime) {
      if (!datetime) return '';

      const date = new Date(datetime);

      const datePart = date.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });

      const timePart = date.toLocaleTimeString('en-US', {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
      });

      return `${datePart} ${timePart}`;
    },
    async getKidsList() {
      let data = {
        profileId: (this.profileId) ? "" : this.profileId,
        search_profile_name: this.profileName,
        search_profile_type: "Android",
        pageSize: 50,
      }
      await KidsService.getKidsList(data)
        .then((response) => {
            this.profileList = response.data.data;
            if (this.profileList.length > 0 && this.profileList[0].deviceDetail) {

                this.showNoDeviceSection = false;
                if (this.profileId) {
                    const selectedProfile = this.profileList.find(item => item._id == this.profileId);
                    this.currentProfile = selectedProfile;
                } else {
                    this.currentProfile = this.profileList[0];
                    this.profileId = this.profileList[0]._id;
                }
                this.kidName = this.currentProfile.profile_name;
                if (this.currentProfile.deviceDetail) {
                    this.birthMonth = this.currentProfile.deviceDetail.birthMonth;
                    this.birthYear = this.currentProfile.deviceDetail.birthYear;
                    this.existingProfilePic = (this.currentProfile.deviceDetail.kidProfilePic) ? this.currentProfile.deviceDetail.kidProfilePic : null;
                    this.showMap = this.currentProfile.deviceDetail.enableLocationMapDisplay
                }

                this.kidsAppProtectionStatus = this.currentProfile.deviceDetail.protectionEnabled;
                this.kidAge = this.currentProfile.deviceDetail.kidAge;
                this.sleepMode = this.currentProfile.sleepMode;
                this.serialNumber = this.currentProfile.deviceDetail.serialNumber;
                
                // Set screen time recommendation based on age
                if (this.kidAge >= 0 && this.kidAge < 2) {
                    this.kidScreenTimeRecommendation = "0 to 2 Years: In babies and toddlers, it is recommended to avoid screen media as much as possible."
                } else if (this.kidAge && this.kidAge >= 2 && this.kidAge < 4) {
                    this.kidScreenTimeRecommendation = "2 to 4 Years: For preschool children, the recommended time ranges from 5 to 10 minutes a day to a maximum of one hour of screen time. The latter should be the exception and not occur every day."
                } else if (this.kidAge && this.kidAge >= 4 && this.kidAge <= 8) {
                    this.kidScreenTimeRecommendation = "4 to 8 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
                } else if (this.kidAge && this.kidAge >= 9 && this.kidAge < 10) {
                    this.kidScreenTimeRecommendation = "9 to 10 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
                } else if (this.kidAge && this.kidAge >= 10) {
                    this.kidScreenTimeRecommendation = "From 10 years: With older children, a weekly time budget can be agreed upon. For example, one hour per year of age per week in the form of media vouchers. Here you find a template: <a target='_blank' href='"+this.mediaVouchers+"'>Template</a>"
                } else {
                    this.kidScreenTimeRecommendation = ""
                }
                
                this.getDeviceProfileMostUsedApplicationList();
                this.getDeviceProfileApplicationList();
                this.getMostUsedCategory();
                this.getCategoryStackedChart();
                
                if (this.currentProfile.deviceDetail.lastDeviceLocation) {
                    let lat = parseFloat(this.currentProfile.deviceDetail.lastDeviceLocation.latitude);
                    let long = parseFloat(this.currentProfile.deviceDetail.lastDeviceLocation.longitude);

                    const centerLat = lat;
                    const centerLong = long;
                    const zoomOutFactor = 0.001;

                    const boundingBox = this.calculateBoundingBox(centerLat, centerLong, zoomOutFactor);
                    const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
                    this.iframeMapUrl = `/map.html?lat=${lat}&long=${long}&zoom=12&bbox=${bbox}`;
                    this.fullMapRedirectUrl = "https://www.openstreetmap.org/?lat="+lat+"&lon="+long+"&zoom=13&layers=Q&mlat="+lat+"&mlon="+long;
                }
                
                if (this.currentProfile.deviceDetail.lastDeviceActivationDate) {
                    this.lastUpdated = new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
                } else {
                    this.lastUpdated = "No data found.";
                }
            } else {
                this.$router.push({ path: '/parent-profile'})
                this.showNoDeviceSection = true;
            }
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
            if (e.response.data.is_logout == true) {
                this.$router.push({ path: '/login'})
            }
        });
    },
    
    switchProfile(profile) {
        this.profileId = profile._id;
        this.$router.replace({
            path: this.$route.path,
            query: { 
                ...this.$route.query,
                profileId: profile._id 
            }
        });
        this.iframeMapUrl = "";
        this.fullMapRedirectUrl = "";
        this.currentProfile = profile;
        this.getDeviceProfileMostUsedApplicationList();
        this.getDeviceProfileApplicationList();
        this.getMostUsedCategory();
        this.getCategoryStackedChart();

        this.kidName = this.currentProfile.profile_name;
        if (this.currentProfile.deviceDetail) {
            this.birthMonth = this.currentProfile.deviceDetail.birthMonth;
            this.birthYear = this.currentProfile.deviceDetail.birthYear;
            this.existingProfilePic = this.currentProfile.deviceDetail.kidProfilePic;
            this.showMap = this.currentProfile.deviceDetail.enableLocationMapDisplay
        }
        this.kidAge = this.currentProfile.deviceDetail.kidAge;
        this.sleepMode = this.currentProfile.sleepMode;
        this.serialNumber = this.currentProfile.deviceDetail.serialNumber;
        
        if (this.kidAge >= 0 && this.kidAge < 2) {
            this.kidScreenTimeRecommendation = "0 to 2 Years: In babies and toddlers, it is recommended to avoid screen media as much as possible."
        } else if (this.kidAge && this.kidAge >= 2 && this.kidAge < 4) {
            this.kidScreenTimeRecommendation = "2 to 4 Years: For preschool children, the recommended time ranges from 5 to 10 minutes a day to a maximum of one hour of screen time. The latter should be the exception and not occur every day."
        } else if (this.kidAge && this.kidAge >= 4 && this.kidAge <= 8) {
            this.kidScreenTimeRecommendation = "4 to 8 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
        } else if (this.kidAge && this.kidAge >= 9 && this.kidAge < 10) {
            this.kidScreenTimeRecommendation = "9 to 10 Years: Kindergarten children and primary school students should not sit in front of the screen for longer than 30 to a maximum of 60 minutes per day."
        } else if (this.kidAge && this.kidAge >= 10) {
            this.kidScreenTimeRecommendation = "From 10 years: With older children, a weekly time budget can be agreed upon. For example, one hour per year of age per week in the form of media vouchers. Here you find a template: <a target='_blank' href='https://www.klicksafe.de/fileadmin/cms/download/Material/Div._Printmedium/Mediengutscheine_klicksafe_Deutsch_2021.pdf'>Template</a>"
        } else {
            this.kidScreenTimeRecommendation = ""
        }
        
        if (this.currentProfile.deviceDetail.lastDeviceLocation) {
            let lat = this.currentProfile.deviceDetail.lastDeviceLocation.latitude;
            let long = this.currentProfile.deviceDetail.lastDeviceLocation.longitude;

            const centerLat = lat;
            const centerLong = long;
            const zoomOutFactor = 0.001;

            const boundingBox = this.calculateBoundingBox(centerLat, centerLong, zoomOutFactor);
            const bbox = `${boundingBox.west},${boundingBox.south},${boundingBox.east},${boundingBox.north}`;
            this.iframeMapUrl = `/map.html?lat=${lat}&long=${long}&zoom=12&bbox=${bbox}`;
            this.fullMapRedirectUrl = "https://www.openstreetmap.org/?lat="+lat+"&lon="+long+"&zoom=13&layers=Q&mlat="+lat+"&mlon="+long;
        }
        
        if (this.currentProfile.deviceDetail.lastDeviceActivationDate) {
            this.lastUpdated = new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleDateString("en-US", this.$dateOptions) + " " + new Date(this.currentProfile.deviceDetail.lastDeviceActivationDate).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})
        } else {
            this.lastUpdated = "No data found.";
        }
        this.kidsAppProtectionStatus = this.currentProfile.deviceDetail.protectionEnabled;
    },
    
    async getDeviceProfileMostUsedApplicationList() {
      if (!this.currentProfile || !this.currentProfile.deviceDetail) return;
      
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      };
      
      try {
        const response = await KidsService.getDeviceProfileMostUsedApplicationList(data);
        this.allMostUsedApplicationList = response.data.data;
        this.totalMostUsedApps = response.data.data.length;
        this.totalUsedTime = response.data.totalUsedTime;
        this.mostUsedApplicationList = response.data.data.slice(0, this.pageSize);
      } catch (e) {
        this.$toast.error(e.response?.data?.respones_msg || 'Error loading apps');
      }
    },
    
    async getDeviceProfileApplicationList() {
      // Placeholder for app list if needed
    },
    
    async getMostUsedCategory() {
      if (!this.currentProfile || !this.currentProfile.deviceDetail) return;
      
      let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      };
      
      try {
        const response = await KidsService.getMostUsedCategory(data);
        this.allMostUsedCategory = response.data.data;
        this.totalMostUsedCategory = response.data.data.length;
        this.mostUsedCategoryList = response.data.data.slice(0, 5);
      } catch (e) {
        this.$toast.error(e.response?.data?.respones_msg || 'Error loading categories');
      }
    },
    
    async getCategoryStackedChart() {
        let data = {
        profileId: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber,
        currentDate: this.currentDate,
        filterType: this.filterType,
        weekType: this.weekType
      }
      await KidsService.getCategoryStackedChart(data)
        .then((response) => {
            this.options = response.data.data
        }).catch((e) => {
          this.$toast.error(e.response.data.respones_msg);
        });
    },
    
    calculateBoundingBox(lat, long, factor) {
      return {
        north: lat + factor,
        south: lat - factor,
        east: long + factor,
        west: long - factor
      };
    },
    
    async toggleSleepMode() {
        try {
            const data = {
            profileId: this.currentProfile._id,
            sleepMode: !this.sleepMode,
            serialNumber: this.currentProfile.deviceDetail.serialNumber
            };

            const response = await KidsService.toggleSleepMode(data);

            this.$toast.success(response?.data?.respones_msg || "Success");

            if (this?.currentProfile?.deviceDetail?.type === "Ios") {
            this.iosApplyPolicy();
            } else {
            this.applyPolicy();
            }
            this.getKidsList();

        } catch (e) {
            const msg =
            e?.response?.data?.respones_msg ||
            e?.message ||
            "Something went wrong";

            this.$toast.error(msg);
        }
    },

    iosApplyPolicy() {
          this.isDisabled = true;
          let data = {
            profile_id: this.currentProfile._id,
          }
          ProfileService.iosApplyPolicy(data)
          .then((response) => {
            this.$toast.success(response.data.respones_msg);
            this.isDisabled = false;
          }).catch((e) => {
            this.$toast.error(e.response.data.respones_msg);
            this.isDisabled = false;
            /*if (e.response.data.data.payment_redirection) {
              this.$router.push({ path: 'plan-list'})
            }*/
          });
    },
    applyPolicy() {
      this.isDisabled = true;
      let data = {
        profile_id: this.currentProfile._id,
        serialNumber: this.currentProfile.deviceDetail.serialNumber
      };

      ProfileService.applyPolicy(data)
        .then((response) => {
          this.isDisabled = false;
          this.$toast.success(response.data.respones_msg);
        })
        .catch((e) => {
          this.isDisabled = false;
          //this.$toast.error(e.response.data.respones_msg);
        });
    },
    
    handleKidSelection(index) {
        if (this.profileList[index]) {
            const profile = this.profileList[index];
            this.$router.push({
                path: '/kids-device',
                query: { 
                    profileId: profile._id,
                    serialNumber: profile.deviceDetail?.serialNumber
                }
            });
        }
    },
    
    handleTabChange(tab) {
      // Handle tab change
      console.log('Tab changed:', tab);
    },
    
    /*previousDate() {
      this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() - 1));
      this.getDeviceProfileMostUsedApplicationList();
      this.getMostUsedCategory();
    },
    
    nextDate() {
      this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() + 1));
      this.getDeviceProfileMostUsedApplicationList();
      this.getMostUsedCategory();
    },*/
    previousDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() - (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions);
        } else {
            this.formattedDate = "Previous Week"
            this.weekType = "Previous";
        }
        this.getCategoryStackedChart();
        this.getDeviceProfileMostUsedApplicationList();
        this.getMostUsedCategory();
    },
    nextDate() {
        if (this.filterType == "Day") {
            let day = this.currentDate.getTime() + (1 * 24 * 60 * 60 * 1000);
            this.currentDate.setTime(day);
            this.formattedDate = this.currentDate.toLocaleDateString("en-US", this.$dateOptions)
        } else {
            this.formattedDate = "This Week",
            this.weekType = "Current";
        }
        
        this.getCategoryStackedChart();
        this.getDeviceProfileMostUsedApplicationList();
        this.getMostUsedCategory();
    },
    
    formatTime(seconds) {
      if (!seconds) return '0m';
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      if (hours > 0) {
        return `${hours}h ${minutes}m`;
      }
      return `${minutes}m`;
    },
    
    calculatePercentage(time) {
      if (!this.totalUsedTime || !time) return 0;
      const total = this.parseTimeToSeconds(this.totalUsedTime);
      return Math.round((time / total) * 100);
    },
    
    calculateCategoryPercentage(time) {
      const total = this.allMostUsedCategory.reduce((sum, cat) => sum + cat.totalUsedTime, 0);
      if (!total || !time) return 0;
      return Math.round((time / total) * 100);
    },
    
    parseTimeToSeconds(timeString) {
      if (!timeString) return 0;
      const hours = timeString.match(/(\d+)h/);
      const minutes = timeString.match(/(\d+)m/);
      return (hours ? parseInt(hours[1]) * 3600 : 0) + (minutes ? parseInt(minutes[1]) * 60 : 0);
    },
    
    getAvatarEmoji(profile) {
      return profile.emoji || '👧';
    },
    
    getAvatarBgClass(profile) {
      return 'bg-orange-400';
    },
    
    getDefaultRules(profile) {
      return profile.defaultRules || '7am - 8:30am';
    },
    
    getLocationName(profile) {
      return profile.deviceDetail?.lastDeviceLocation?.name || 'Unknown Location';
    },
    
    getLocationTime(profile) {
      return '2 minutes ago';
    },
    
    getAppIconBg(index) {
      const colors = ['#fce7f3', '#fee2e2', '#dcfce7', '#e9d5ff', '#dbeafe', '#fef3c7'];
      return colors[index % colors.length];
    },
    
    getAppBarColor(index) {
      const colors = ['#ec4899', '#ef4444', '#10b981', '#a855f7', '#3b82f6', '#f59e0b'];
      return colors[index % colors.length];
    },
    
    getCategoryIcon(category) {
      const icons = {
        'Gaming': '🎮',
        'Entertainment': '🎵',
        'Social': '💬',
        'Education': '📚',
        'Productivity': '🔧',
        'Tools': '🛠️'
      };
      return icons[category] || '📱';
    },

    getBatteryIcon(percentage) {
        if (percentage === null || percentage === undefined) return '🔋';
        return percentage >= 15 ? '🔋' : '🪫';
    },

    getBatteryColor(percentage) {
        if (percentage >= 90) return '#22c55e';      // green
        if (percentage >= 70) return '#16a34a';      // green
        if (percentage >= 50) return '#84cc16';      // yellow-green
        if (percentage >= 30) return '#facc15';      // yellow
        if (percentage >= 15) return '#f97316';      // orange
        return '#ef4444';                            // red
    },
    
    getCategoryIconBg(category) {
      const colors = {
        'Gaming': '#3b82f6',
        'Entertainment': '#a855f7',
        'Social': '#ec4899',
        'Education': '#10b981',
        'Productivity': '#6b7280',
        'Tools': '#06b6d4'
      };
      return colors[category] || '#6b7280';
    },

    openEditKidModal() {
        this.showEditKidModal = true;
    },

    closeEditKidModal() {
        this.showEditKidModal = false;
        this.newProfilePic = null;
        this.kidProfileImagePayload = null;
    },

    handleFileUpload(event) {
        const file = event.target.files[0];
        this.kidProfileImagePayload = file;
        if (file) {
            this.newProfilePic = URL.createObjectURL(file);
        }
    },

    async updateKidProfileDetail() {
        this.isDisabled = true;
        let formData = new FormData();
        formData.append("image", this.kidProfileImagePayload);
        formData.append("kidName", this.kidName); 
        formData.append("birthMonth", this.birthMonth)
        formData.append("birthYear", this.birthYear);
        formData.append("profileId", this.currentProfile._id);
        formData.append("serialNumber", this.currentProfile.deviceDetail.serialNumber);
        
        try {
            const response = await KidsService.updateKidProfileDetail(formData);
            await this.getKidsList();
            this.newProfilePic = null;
            this.kidProfileImagePayload = null;
            this.isDisabled = false;
            this.$toast.success(response.data.respones_msg);
            this.closeEditKidModal();
        } catch (e) {
            this.isDisabled = false;
            this.$toast.error(e.response?.data?.respones_msg || 'Update failed');
        }
    },
    openProtectionModal() {
        if (this.currentProfile?.deviceDetail?.kidsApplicationStatus !== 'Healthy') {
            this.showProtectionModal = true;
        }
    },

    closeProtectionModal() {
        this.showProtectionModal = false;
    },
    openScreenTimeRecommendation() {
        this.showScreenTimeModal = true;
    },

    closeScreenTimeRecommendation() {
        this.showScreenTimeModal = false;
    },
    handleProfileChange() {
        // Update from route
        this.profileId = this.$route.query.profileId;
        this.serialNumber = this.$route.query.serialNumber;
        
        // Reload all data
        this.getKidsList();
    }
  },
  mounted() {
    this.getKidsList();
  },
  beforeMount() {
    if (window.Android && typeof Android.sendData === "function") {
        Android.sendData(localStorage.getItem('token'));
    } else {
        console.log("Android interface is not available");
    }

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.iosHandler) {
        window.webkit.messageHandlers.iosHandler.postMessage(localStorage.getItem('token'));
    } else {
        console.log("iOS interface is not available");
    }

  },
   created() {
    this.hideGoogleLogin = localStorage.getItem('hideGoogleLogin') === 'true';
  },
  watch: {
    filterType() {
      this.getDeviceProfileMostUsedApplicationList();
      this.getMostUsedCategory();
      this.getCategoryStackedChart()
    },
    '$route.query.profileId': {
        handler(newProfileId, oldProfileId) {
            if (newProfileId && newProfileId !== oldProfileId) {
                this.handleProfileChange();
            }
        }
    },
    
  }
}
</script>

<style scoped>
/* Additional component-specific styles */
.bg-orange-400 {
    background-color: #fb923c;
}
.bg-blue-400 {
    background-color: #60a5fa;
}
.bg-teal-400 {
    background-color: #2dd4bf;
}

/* Alerts Modal Centered */
/* Edit Kid Modal & Alerts Modal Centered */
.theme2-alerts-modal {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
  bottom: auto !important;
  max-height: 80vh;
  border-radius: 0.75rem;
  max-width: 600px;
  width: 90%;
  z-index: 2000 !important; /* Higher than header/nav */
}

/* Modal Overlay z-index */
.theme2-modal-overlay {
  z-index: 1999 !important; /* Just below modal */
}
/* Alert Items */
.alert-item {
  display: flex;
  gap: 1rem;
  padding: 1.25rem;
  border-bottom: 1px solid #f3f4f6;
  transition: background 0.2s;
}

.alert-item:hover {
  background: #f9fafb;
}

.alert-item:last-child {
  border-bottom: none;
}

.alert-danger {
  background: #fef2f2;
  border-left: 4px solid #ef4444;
}

.alert-warning {
  background: #fffbeb;
  border-left: 4px solid #f59e0b;
}

.alert-info {
  background: #eff6ff;
  border-left: 4px solid #3b82f6;
}

.alert-icon {
  font-size: 2rem;
  flex-shrink: 0;
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.alert-content {
  flex: 1;
  min-width: 0;
}

.alert-title {
  font-size: 1rem;
  font-weight: 700;
  color: #111827;
  margin-bottom: 0.5rem;
}

.alert-message {
  font-size: 0.875rem;
  color: #4b5563;
  line-height: 1.6;
  margin-bottom: 0.75rem;
}

.alert-message strong {
  color: #dc2626;
  font-weight: 600;
}

.alert-action-btn {
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3);
}

.alert-action-btn:hover {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 6px rgba(59, 130, 246, 0.4);
}

.alert-action-btn:active {
  transform: translateY(0);
}

.theme2-stat-card-error {
    border-color: #fecaca !important;
    background: #fef2f2 !important;
    animation: pulse-error 2s ease-in-out infinite;
}

@keyframes pulse-error {
    0%, 100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.4); }
    50% { box-shadow: 0 0 0 8px rgba(239, 68, 68, 0); }
}
.theme2-profile-card {
    background: linear-gradient(135deg, #0ea5e9 0%, #06b6d4 100%);
    border-radius: 0.75rem;
    padding: 1rem;
    margin-bottom: 1rem;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);
}

.theme2-profile-header {
    margin-bottom: 0.75rem;
}

.theme2-profile-info {
    display: flex;
    align-items: center;
    gap: 0.75rem;
}

.theme2-profile-avatar {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.875rem;
    border: 4px solid white;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
    position: relative;
    flex-shrink: 0;
}

.theme2-online-indicator {
    position: absolute;
    bottom: -0.25rem;
    right: -0.25rem;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    border: 2px solid white;
}

.theme2-profile-name {
    font-size: 1.25rem;
    font-weight: 700;
    color: white;
    margin: 0 0 0.125rem 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.theme2-profile-rules {
    color: rgba(255, 255, 255, 0.8);
    font-size: 0.75rem;
    margin: 0;
}

/* Status Row - Horizontal badges */
.theme2-status-row {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
    overflow-x: auto;
    scrollbar-width: none;
    -webkit-overflow-scrolling: touch;
}

.theme2-status-row::-webkit-scrollbar {
    display: none;
}

.theme2-status-badge {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 0.5rem;
    padding: 0.375rem 0.75rem;
    font-size: 0.75rem;
    color: white;
    font-weight: 600;
    white-space: nowrap;
    flex-shrink: 0;
    
}

.theme2-status-badge {
    flex: 0 0 auto;        /* Don't grow */
    min-width: auto;       /* Natural width */
}

.theme2-last-update-badge {
    flex: 0 0 auto;        /* Don't grow */
    max-width: fit-content; /* Compact size */
}

/* Buttons have max width */
.theme2-action-btn {
    max-width: 200px;      /* Don't stretch too wide */
}
.theme2-status-badge span:first-child {
    font-size: 1rem;
}

.theme2-last-update-badge {
    flex: 1;
    min-width: 0;
}

.theme2-last-update-badge span:last-child {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Action Buttons Row */
.theme2-actions-row {
    display: flex;
    gap: 0.5rem;
}

.theme2-action-btn {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.375rem;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 0.5rem;
    padding: 0.625rem 0.75rem;
    font-weight: 600;
    font-size: 0.8125rem;
    color: white;
    border: none;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
}

.theme2-action-btn:hover {
    background: rgba(255, 255, 255, 0.3);
}

.theme2-action-btn:active {
    transform: scale(0.98);
}

.theme2-action-btn.active {
    background: #a855f7;
}

.theme2-action-btn span:first-child {
    font-size: 1.125rem;
}

/* Mobile Optimizations */
@media (max-width: 768px) {
    .theme2-profile-card {
        border-radius: 0.75rem;
        margin-bottom: 0.5rem;
        padding: 0.875rem;
    }

    .theme2-profile-avatar {
        width: 3rem;
        height: 3rem;
        font-size: 1.5rem;
    }

    .theme2-profile-name {
        font-size: 1.125rem;
    }

    .theme2-status-badge {
        padding: 0.3125rem 0.625rem;
        font-size: 0.6875rem;
    }

    .theme2-status-badge span:first-child {
        font-size: 0.875rem;
    }

    .theme2-action-btn {
        padding: 0.5625rem 0.625rem;
        font-size: 0.75rem;
    }

    .theme2-action-btn span:first-child {
        font-size: 1rem;
    }
}

@media (max-width: 480px) {
    .theme2-profile-avatar {
        width: 2.5rem;
        height: 2.5rem;
        font-size: 1.25rem;
        border-width: 3px;
    }

    .theme2-profile-name {
        font-size: 1rem;
    }

    .theme2-profile-rules {
        font-size: 0.6875rem;
    }

    .theme2-status-badge {
        padding: 0.25rem 0.5rem;
        font-size: 0.625rem;
    }

    .theme2-action-btn {
        padding: 0.5rem 0.5rem;
        font-size: 0.6875rem;
        gap: 0.25rem;
    }
}


/* Add wrapper for desktop single-row layout */
.theme2-status-actions-wrapper {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

/* Desktop - Single Row */
@media (min-width: 769px) {
    .theme2-status-actions-wrapper {
        flex-direction: row; /* Single row on desktop */
        align-items: center;
        gap: 0.5rem;
    }

    .theme2-status-row {
        flex: 1; /* Take available space */
        margin-bottom: 0; /* Remove bottom margin */
    }

    .theme2-actions-row {
        flex: 0 0 auto; /* Don't grow */
        gap: 0.5rem;
    }

    .theme2-action-btn {
        min-width: 150px; /* Ensure readable width */
        max-width: 180px;
    }
}

/* Mobile - Keep stacked (no changes) */
@media (max-width: 768px) {
    .theme2-status-actions-wrapper {
        flex-direction: column; /* Stack on mobile */
    }
}
</style>